module.exports = __webpack_public_path__ + "img/west-vvip-gal-3.da7ece10.jpg";